import { render, staticRenderFns } from "./ProductReview.vue?vue&type=template&id=66fa5e88&"
import script from "./ProductReview.vue?vue&type=script&lang=js&"
export * from "./ProductReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports